import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  FormControl,
  Grid,
  InputLabel,
  Select,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  // FormControlLabel,
  Checkbox,
  TextField,
  // Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  MenuItem,
  Menu,
} from '@material-ui/core';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import './styles/settingview.css';
import { withTranslation } from 'react-i18next';

import TimeField from 'react-simple-timefield';
import Swal from 'sweetalert2';
// import { array } from 'prop-types';

class Setting extends React.PureComponent {
  constructor(props) {
    super(props);
    // this.state = this.props.state;
    this.state = {
      anchorEl: null,
      name: '',
    };
  }

  handleMove = async () => {
    this.props.handleClose();
  };

  handleClose = () => {
    this.props.handleClose();
  };

  changeData(key, value) {
    this.data.patient[key] = value;
  }

  handleChangeProfile = async (event) => {
    const { settings } = this.props.settingProfile.toJS();
    const profileData = settings.data.find((val) => val.id === event);
    await this.props.setting.setWarningSettings(profileData);

    this.setState({
      anchorEl: null,
    });
  };

  handleChange = (name) => (event) => {
    this.props.setting.changeData(name, event.target.checked);
  };

  handleSelectChange = (name) => (event) => {
    if (name === 'intoAreaRID') {
      this.props.setting.changeData(name, event);
    } else if (name === 'intoBuilding') {
      let value = [];
      event.map((val) => {
        value.push(val.value);
        return true;
      });
      this.props.setting.changeData(name, value);
    } else if (name === 'outOfBuilding') {
      let value = [];
      event.map((val) => {
        value.push(val.value);
        return true;
      });
      this.props.setting.changeData(name, value);
    } else {
      this.props.setting.changeData(name, event.target.value);
    }
  };

  handleTimeChange = (event, value) => {
    this.props.setting.changeData(event, value);
  };

  handleSave = (patient) => async () => {
    if (this.validate()) {
      const { dataList } = this.props;
      await this.props.dashboard.setDataList(dataList);
      await this.props.setting.settingUpdate(patient);
      this.props.handleClose();
    }
  };

  validate() {
    let { data } = this.props.setting.toJS();
    const { t } = this.props;

    if (data.notTurnFor) {
      if (
        (data.notTurnForHours === 0 || data.notTurnForHours === '0') &&
        (data.notTurnForMinutes === 0 || data.notTurnForMinutes === '0')
      ) {
        Swal.fire({
          html: `<h4>${t('failed_not_turn_for')}`,
          confirmButtonText: `${t('ok')}`,
          type: 'warning',
          // width: 400,
          customClass: {
            container: 'my-swal',
          },
        });
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  settingDefault = async () => {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('replace_setting')}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: `${t('ok')}`,
      cancelButtonText: `${t('cancel')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          await this.props.setting.getDefaultWarningSettings();
        } catch (err) {
          Swal.fire({
            html: `<h4>${t('failed_to_update')}`,
            confirmButtonText: `${t('ok')}`,
            type: 'warning',
            customClass: {
              container: 'my-swal',
            },
          });
        }
      }
    });
  };

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleCloseMenu = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleMenuItemClick = (event) => {
    this.setState({
      anchorEl: null,
      valueId: event.target.value,
    });
  };

  getSettingProfileName = (id) => {
    const { t } = this.props;
    const { settings } = this.props.settingProfile.toJS();
    const profileData = settings.data.find((val) => val.id === id);
    return (
      <span
        style={{
          maxWidth: '100px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {profileData ? profileData.name : t('customize')}
      </span>
    );
  };

  render() {
    let { props, state, t, patientData } = this.props;
    let { data } = this.props.setting.toJS();
    // const { routers } = this.props.router.toJS();
    const { settings } = this.props.settingProfile.toJS();
    const { areas } = this.props.area.toJS();
    const patient = props.data ? props.data.patient : patientData;
    const devices = patient.devices;
    const isMotionTracker = (devices || []).find((val) => {
      return (
        val.deviceVersion &&
        (val.deviceVersion.name.toUpperCase().includes('AIR') || val.deviceVersion.name.toUpperCase().includes('EYE'))
      );
    });

    // let routersDefault = routers.filter(
    //   (router) => router.status === "ACTIVATED" && router.outOfAreaDefault === 1
    // );

    // const routersDefaultRow = routersDefault.length;
    // get list of routers, filter-out 'OutOfArea' routers
    // let routersNormal = routers.filter(router => (router.status === 'ACTIVATED' && !router.outOfAreaDefault && router.mapId));
    // routersNormal = routersNormal.map(router => {
    //   let list = {};
    //   list.label = `${router.name}-${router.id}`;
    //   list.value = router.serial;
    //   return list
    // });
    // // sort intoArea routers by label
    // routersNormal.sort((a, b) => (a.label > b.label) ? 1 : -1);
    // get list of selected intoArea routers
    // let selectedOption = data.intoAreaRID;

    // get list of areas
    let areasBuilding = areas.data.map((val) => {
      let list = {};
      list.label = `${val.name}`;
      list.value = val.id;
      return list;
    });

    // sort Area routers by label
    areasBuilding.sort((a, b) => (a.label > b.label ? 1 : -1));

    // get list of selected intoBuilding routers
    let selectedOptionArea = (areasBuilding || []).filter(
      (val) => data.intoBuilding && data.intoBuilding.includes(val.value),
    );
    let selectedOptionOutOfBuilding = (areasBuilding || []).filter(
      (val) => data.outOfBuilding && data.outOfBuilding.includes(val.value),
    );
    return (
      <Dialog
        open={state.dialogSetting.open}
        onClose={this.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle
          className='header'
          onClose={this.handleClose}
          id='form-dialog-title'
          style={{ padding: '16px 24px 5px' }}
        >
          <Grid container item md={12} style={{ position: 'relative' }}>
            {t('alert_settings_for')} <span className='headerMain'>{`${patient.firstname} ${patient.lastname}`}</span>
            <div className='closeIcon' onClick={this.handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>

          <Grid container item md={12}>
            <Button
              onClick={this.handleClick}
              variant='contained'
              color='primary'
              id='defaultSetting'
              style={{
                width: 100,
                marginTop: 5,
              }}
            >
              {this.getSettingProfileName(data.settingProfileId || 0)}
            </Button>
            <Menu
              id='grid-menu'
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={this.handleCloseMenu}
              // className={props.classes.gridMenu}
            >
              <MenuItem
                fullwidth='true'
                key={0}
                value={0}
                selected={data.settingProfileId === 0}
                onClick={(e) => this.handleChangeProfile(e.target.value)}
              >
                {t('customize')}
              </MenuItem>
              {settings.data.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  selected={option.id === data.settingProfileId}
                  onClick={(e) => this.handleChangeProfile(e.target.value)}
                >
                  {option.name}
                </MenuItem>
              ))}
            </Menu>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ minHeight: '500px', overflow: 'unset' }}>
          <List component='nav' aria-label='folders'>
            {isMotionTracker && (
              <React.Fragment>
                <ListItem key={1} role={undefined} divider={true} className={props.classes.SettingList}>
                  <ListItemIcon className='listItemIconMain'>
                    <Checkbox
                      edge='start'
                      onChange={this.handleChange('getup')}
                      checked={data.getup ? true : false}
                      value='getup'
                      id='getup'
                      color='primary'
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t('get_up')}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className='ItemSecondaryActionMain'></ListItemSecondaryAction>
                </ListItem>
                <ListItem key={2} role={undefined} divider={true} className={props.classes.SettingList}>
                  <ListItemIcon className='listItemIconMain'>
                    <Checkbox
                      edge='start'
                      onChange={this.handleChange('walkingAt')}
                      checked={data.walkingAt ? true : false}
                      value='walkingAt'
                      id='walkingAt'
                      color='primary'
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t('walking')}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className='time ItemSecondaryActionMain'>
                    <Grid container item md={6} xs={6} sm={6}>
                      <Grid container item xs={6} sm={6}>
                        <TimeField
                          // showSeconds
                          id='walkingAtStart'
                          value={data.walkingStart || '22:00'}
                          onChange={(e) => this.handleTimeChange('walkingStart', e.target.value)}
                          input={
                            <TextField
                              variant='outlined'
                              margin='dense'
                              id='time'
                              label={t('from')}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={data.walkingStart || '22:00'}
                              className={props.classes.textfield}
                            />
                          }
                        />
                      </Grid>
                      <Grid container item xs={6} sm={6}>
                        <TimeField
                          // showSeconds
                          id='walkingAtEnd'
                          style={{ marginLeft: 58 }}
                          value={data.walkingEnd || '04:00'}
                          onChange={(e) => this.handleTimeChange('walkingEnd', e.target.value)}
                          input={
                            <TextField
                              variant='outlined'
                              margin='dense'
                              id='time'
                              label={t('to')}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={data.walkingEnd || '04:00'}
                              className={props.classes.textfield}
                            />
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItemSecondaryAction>
                </ListItem>

                <ListItem key={3} role={undefined} divider={true} className={props.classes.SettingList}>
                  <ListItemIcon className='listItemIconMain'>
                    <Checkbox
                      edge='start'
                      onChange={this.handleChange('movement')}
                      checked={data.movement ? true : false}
                      value='movement'
                      id='movement'
                      color='primary'
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t('movement')}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                    <Grid container item md={6} xs={12}>
                      <Grid container item xs={6} sm={6}>
                        <FormControl variant='outlined' fullWidth className={props.classes.formSelect}>
                          <InputLabel
                            htmlFor='outlined-movementLevel'
                            margin='dense'
                            className={props.classes.textLabelSelect}
                          >
                            {t('sensitivity')}
                          </InputLabel>
                          <Select
                            native
                            value={data.movementLevel || 1}
                            onChange={this.handleSelectChange('movementLevel')}
                            className={props.classes.selectOption}
                            margin='dense'
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name='movementLevel'
                                id='outlined-movementLevel'
                                margin='dense'
                              />
                            }
                          >
                            <option value={1} label={t('low')}></option>
                            <option value={2} label={t('medium')}></option>
                            <option value={3} label={t('high')}></option>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </ListItemSecondaryAction>
                </ListItem>
              </React.Fragment>
            )}

            {isMotionTracker && (
              <React.Fragment>
                <ListItem key={6} role={undefined} divider={true} className={props.classes.SettingList}>
                  <ListItemIcon className='listItemIconMain'>
                    <Checkbox
                      edge='start'
                      onChange={this.handleChange('notTurnFor')}
                      checked={data.notTurnFor ? true : false}
                      value='notTurnFor'
                      id='notTurnFor'
                      color='primary'
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t('not_turn_for')}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                    <Grid container item md={6} xs={6} sm={6}>
                      <Grid container item xs={6} sm={6}>
                        <FormControl variant='outlined' fullWidth className={props.classes.formSelect}>
                          <InputLabel
                            htmlFor='filled-age-native-simple'
                            margin='dense'
                            className={props.classes.textLabelSelect}
                          >
                            {t('hours')}
                          </InputLabel>
                          <Select
                            native
                            className={props.classes.selectOption}
                            value={data.notTurnForHours || 0}
                            onChange={this.handleSelectChange('notTurnForHours')}
                            margin='dense'
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name='notTurnForHours'
                                id='filled-notTurnForHours'
                                margin='dense'
                              />
                            }
                          >
                            <option value={0}>0</option>
                            <option value={1}>1</option>
                            <option value={2}>2</option>
                            <option value={3}>3</option>
                            <option value={4}>4</option>
                            <option value={5}>5</option>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid container item xs={6} sm={6}>
                        <FormControl
                          variant='outlined'
                          fullWidth
                          className={props.classes.formSelect}
                          style={{ marginLeft: 65 }}
                        >
                          <InputLabel
                            htmlFor='filled-age-native-simple'
                            margin='dense'
                            className={props.classes.textLabelSelect}
                          >
                            {t('minutes')}
                          </InputLabel>
                          <Select
                            native
                            className={props.classes.selectOption}
                            value={data.notTurnForMinutes || 0}
                            onChange={this.handleSelectChange('notTurnForMinutes')}
                            margin='dense'
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name='notTurnForMinutes'
                                id='filled-notTurnForMinutes'
                                margin='dense'
                              />
                            }
                          >
                            <option value={0}>0</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={40}>40</option>
                            <option value={50}>50</option>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem key={7} role={undefined} divider={true} className={props.classes.SettingList}>
                  <ListItemIcon className='listItemIconMain'>
                    <Checkbox
                      edge='start'
                      onChange={this.handleChange('noMovementFor')}
                      checked={data.noMovementFor ? true : false}
                      value='noMovementFor'
                      id='noMovementFor'
                      color='primary'
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t('no_movement')}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className='ItemSecondaryActionMain'>
                    <Grid container item md={6} xs={12}>
                      <Grid container item xs={6} sm={6}>
                        <FormControl variant='outlined' fullWidth className={props.classes.formSelect}>
                          <InputLabel
                            htmlFor='filled-age-native-simple'
                            margin='dense'
                            className={props.classes.textLabelSelect}
                          >
                            {t('days')}
                          </InputLabel>
                          <Select
                            native
                            className={props.classes.selectOption}
                            value={data.noMovementForDay || 1}
                            onChange={this.handleSelectChange('noMovementForDay')}
                            margin='dense'
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name='noMovementForDay'
                                id='filled-noMovementForDay'
                                margin='dense'
                              />
                            }
                          >
                            <option value={1}>1</option>
                            <option value={2}>2</option>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem key={8} role={undefined} divider={true} className={props.classes.SettingList}>
                  <ListItemIcon className='listItemIconMain'>
                    <Checkbox
                      edge='start'
                      onChange={this.handleChange('fall')}
                      checked={data.fall ? true : false}
                      value='fall'
                      id='fall'
                      color='primary'
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t('fall')}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
                </ListItem>
              </React.Fragment>
            )}
            <ListItem key={9} role={undefined} divider={true} className={props.classes.SettingList}>
              <ListItemIcon className='listItemIconMain'>
                <Checkbox
                  edge='start'
                  onChange={this.handleChange('intoArea')}
                  checked={data.intoArea ? true : false}
                  value='intoArea'
                  id='intoArea'
                  color='primary'
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography>{t('into')}</Typography>
                  </React.Fragment>
                }
              />
              <ListItemSecondaryAction
                className='ItemSecondaryActionMain zIndexMultiSelect'
                style={{ fontFamily: 'Kanit,sans-serif' }}
              >
                <ReactMultiSelectCheckboxes
                  dropdownButton={{ width: '100%' }}
                  className='routerList'
                  options={areasBuilding}
                  onChange={this.handleSelectChange('intoBuilding')}
                  value={selectedOptionArea}
                  id='intoBuilding'
                  placeholderButtonLabel={t('area') + '...'}
                  placeholder={t('search') + '...'}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem key={10} role={undefined} divider={true} className={props.classes.SettingList}>
              <ListItemIcon className='listItemIconMain'>
                <Checkbox
                  edge='start'
                  onChange={this.handleChange('outOfArea')}
                  checked={data.outOfArea ? true : false}
                  value='outOfArea'
                  id='outOfArea'
                  color='primary'
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography>{t('outOf')}</Typography>
                  </React.Fragment>
                }
              />
              <ListItemSecondaryAction
                className='ItemSecondaryActionMain zIndexList'
                style={{ fontFamily: 'Kanit,sans-serif' }}
              >
                <ReactMultiSelectCheckboxes
                  dropdownButton={{ width: '100%' }}
                  className='routerList'
                  options={areasBuilding}
                  onChange={this.handleSelectChange('outOfBuilding')}
                  value={selectedOptionOutOfBuilding}
                  id='outOfBuilding'
                  placeholderButtonLabel={t('area') + '...'}
                  placeholder={t('search') + '...'}
                  isOpen={false}
                />
                {/* {'** Default : '}
                {(routersDefault || []).map((val,i) => (
                  <span key={val.id}>{`${val.name || ' - '}`}{routersDefaultRow !== i+1 && ' , '}</span> 
                ))}
                {' **'} */}
              </ListItemSecondaryAction>
            </ListItem>

            <ListItem key={4} role={undefined} divider={true} className={props.classes.SettingList}>
              <ListItemIcon className='listItemIconMain'>
                <Checkbox
                  edge='start'
                  onChange={this.handleChange('lowBattery')}
                  checked={data.lowBattery ? true : false}
                  value='lowBattery'
                  id='lowBattery'
                  color='primary'
                  tabIndex={-1}
                  disableRipple
                  disabled
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography>{t('low_battery')}</Typography>
                  </React.Fragment>
                }
              />
              <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
            </ListItem>

            <ListItem key={5} role={undefined} divider={true} className={props.classes.SettingList}>
              <ListItemIcon className='listItemIconMain'>
                <Checkbox
                  edge='start'
                  onChange={this.handleChange('noSignal')}
                  checked={data.noSignal ? true : false}
                  value='noSignal'
                  id='noSignal'
                  color='primary'
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography>{t('no_signal')}</Typography>
                  </React.Fragment>
                }
              />
              <ListItemSecondaryAction className='ItemSecondaryActionMain'> </ListItemSecondaryAction>
            </ListItem>

            {/* {routersDefault && routersDefault.length > 0 && (
              <React.Fragment>
                <ListItem
                  key={10}
                  role={undefined}
                  className={props.classes.SettingList}
                >
                  <ListItemIcon className="listItemIconMain">
                    <Checkbox
                      edge="start"
                      onChange={this.handleChange("outOfArea")}
                      // checked={data.outOfArea}
                      checked={true}
                      value="outOfArea"
                      id="outOfArea"
                      color="primary"
                      tabIndex={-1}
                      disableRipple
                      disabled
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography>{t("out_of_area")}</Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction className="ItemSecondaryActionMain selectList">
                    <Typography color="textSecondary">
                      {`** ${t("default")} : `}
                      {(routersDefault || []).map((val, i) => (
                        <span key={val.id}>
                          {`${val.name || " - "}`}
                          {routersDefaultRow !== i + 1 && " , "}
                        </span>
                      ))}
                      {" **"}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
              </React.Fragment>
            )} */}
          </List>
          <Grid container></Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            item
            style={{
              margin: '10px 28px',
              justifyContent: 'right',
            }}
          >
            <Button
              onClick={this.handleSave(patient)}
              color='primary'
              id='save'
              variant='contained'
              style={{
                width: 100,
              }}
            >
              {t('save')}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

export const page = inject('setting', 'router', 'dashboard', 'settingProfile', 'area')(observer(Setting));
export const translation = withTranslation()(page);
export default withStyles({ withTheme: true })(translation);
